import { render } from "./addLearnerToCourse.vue?vue&type=template&id=3ea72c05&scoped=true"
import script from "./addLearnerToCourse.vue?vue&type=script&lang=js"
export * from "./addLearnerToCourse.vue?vue&type=script&lang=js"

import "./addLearnerToCourse.vue?vue&type=style&index=0&id=3ea72c05&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea72c05"]])

export default __exports__